module.exports = __webpack_public_path__ + "media/images/city/081-hallgrimskirkja-a458825a640ac1fa6c2b509da0d87cae.svg";